import { takeLatest } from 'redux-saga/effects'
import actionTypes from './actionTypes'

import { loginSaga, logoutSaga } from './user/userSagas'

export default function* watchSagas(): Generator {
  // AUTH
  yield takeLatest(actionTypes.LOGIN, loginSaga)
  yield takeLatest(actionTypes.LOGOUT, logoutSaga)
}
